'use client';

import { useSearchParams } from 'next/navigation';
import { FunctionComponent, useMemo } from 'react';

export const Heading: FunctionComponent = () => {
    const searchParams = useSearchParams();
    const referredBy = useMemo(() => searchParams?.get('rfrl'), [searchParams]);

    if (referredBy) {
        return (
            <div>
                <h1>{referredBy} is recommending Cademy to you!</h1>
            </div>
        );
    }

    return (
        <div>
            <h1>Your All-in-One Solution for Courses & Training</h1>
        </div>
    );
};
